import React, { useState, useEffect } from "react"
import ShopQuickNav from "./ShopQuickNav"

function ClothingPage() {
  const [filter, setFilter] = useState("newest")

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const products = [
    {
      title: "Healthy Hero Toddler Tee",
      description: "Featuring smiling sun and fruit characters!",
      icon: "☀️",
      color: "yellow",
      isNew: false
    },
    {
      title: "Zoo Crew Snapback Hat",
      description: "Join the zoo crew with this fun hat!",
      icon: "🧢",
      color: "orange",
      isNew: false
    },
    {
      title: "Rainbow Splash Rain Jacket",
      description: "Stay dry in colorful style!",
      icon: "🌈",
      color: "sky",
      isNew: true
    },
    {
      title: "Adventure Backpack",
      description: "Perfect for little explorers!",
      icon: "🎒",
      color: "lime",
      isNew: true
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-100 to-yellow-50">
      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Back Button */}
        <a 
          href="/" 
          onClick={() => localStorage.setItem('scrollTarget', 'shop')}
          className="inline-flex items-center gap-2 text-lime-600 hover:text-sky-500 font-bold text-xl mb-8 transition-colors duration-300"
          style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}
        >
          ← Back to Sandbox Shop
        </a>

        {/* Page Title */}
        <h2 className="text-4xl md:text-6xl font-black mb-8" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
          <span className="text-lime-600">👕 Kids Clothing & Gear</span>
        </h2>

        {/* Quick Navigation Bar */}
        <ShopQuickNav />

        {/* Filter Dropdown */}
        <div className="mb-12">
          <label className="text-lg font-bold text-gray-700 mr-4">Filter by:</label>
          <select 
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="px-6 py-3 rounded-full border-4 border-lime-400 bg-white font-bold text-gray-700 shadow-lg focus:outline-none focus:ring-4 focus:ring-lime-300 transition-all duration-300"
            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}
          >
            <option value="newest">Newest</option>
            <option value="bestsellers">Best Sellers</option>
            <option value="age-0-3">Age 0-3</option>
            <option value="age-4-6">Age 4-6</option>
            <option value="age-7+">Age 7+</option>
          </select>
        </div>

        {/* Products Grid - 2 columns on mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-6 border-lime-400 relative"
            >
              {product.isNew && (
                <div className="absolute top-2 right-2 bg-red-500 text-white px-3 py-1 rounded-full font-bold text-xs shadow-lg z-10">
                  🆕 New
                </div>
              )}
              <div className="p-4">
                <div className="aspect-square rounded-2xl bg-gradient-to-br from-lime-200 to-green-300 mb-3 flex items-center justify-center">
                  <span className="text-5xl md:text-7xl">{product.icon}</span>
                </div>
                <h4 className="text-base md:text-xl font-bold text-gray-800 mb-2">{product.title}</h4>
                <p className="text-sm md:text-base text-gray-600 mb-3">{product.description}</p>
                <button className="w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black py-2 md:py-3 px-4 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95 text-sm md:text-base">
                  🛒 Buy on Amazon
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-sky-500 via-lime-500 to-yellow-400 text-white py-8 mt-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-xl md:text-2xl font-bold" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            © 2026 Tiny Tots Sandbox - Where Imagination Meets Education! ✨
          </p>
        </div>
      </footer>
    </div>
  )
}

export default ClothingPage
